import React,{useState,useEffect,useContext} from 'react'
import essTaskServices from '../app/ess/EssTask/essTaskServices';
import essProjectServices from '../app/ess/ESSAssignedProject/essProjectServices';
import essTeamServices from '../app/ess/EssTeam/essTeamServices';
import essMasterServices from '../app/master/essMasterServices';
const AppESSDataContext = React.createContext();

export const useEssAppData = () => {
    return useContext(AppESSDataContext);
}

export const AppESSDataProvider = (props) =>{

    const [loading,setLoadingStatus] = useState(false)
    const [taskList,setTaskList] = useState(null);
    const [archivedTaskList,setArchivedTaskList] = useState(null);
    const [projectList,setProjectList] = useState(null);
    const [teamList,setTeamList] = useState(null);
    const [workLocation,setWorkLocation] = useState(null);
    const [employeeDetails,setEmployeeDetails] = useState(null);
    
    const getTaskList = () =>{
        setLoadingStatus(true);
        essTaskServices.getList().then(res=>{
            setTaskList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getArchivedTaskList = () =>{
        setLoadingStatus(true);
        essTaskServices.getArchivedList().then(res=>{
            setArchivedTaskList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
 
    const getProjectList = () =>{
        setLoadingStatus(true);
        essProjectServices.getProjectList().then(res=>{
            setProjectList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getTeamList = () =>{
        setLoadingStatus(true);
        essTeamServices.getTeamList().then(res=>{
            setTeamList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    


    const getEssAppData = () =>{
        essMasterServices.getEssData().then(res=>{
            setTaskList(res.data.taskList);
            setArchivedTaskList(res.data.archivedTaskList);
            setProjectList(res.data.projectList);
            setTeamList(res.data.teamList);
            setWorkLocation(res.data.workLocation);
            //setUserDD(res.data.userDD);
            //setEmployeeDD(res.data.employeeDD);
            setEmployeeDetails(res.data.employeeDetails);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
        })

    }
    

    

    const value= {
        taskList,getTaskList,
        archivedTaskList,getArchivedTaskList,
        projectList,getProjectList,
        teamList,getTeamList,
        workLocation,
        employeeDetails,
        loading
    }

    useEffect(()=>{
        //getTaskList();
        //getProjectList();
        //getTeamList();
        getEssAppData();
    },[])
    
    return (
        taskList && projectList && teamList &&
        <AppESSDataContext.Provider value= {value}>{props.children}</AppESSDataContext.Provider>
    )
}